import { getToken, getUserId } from "./authHelper";

export const fetchUserData = async (setLoading, setUserProfile) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  try {
    setLoading(true);
    const response = await fetch(`${apiUrl}/auth:current`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    const data = await response.json();
    setUserProfile(data.results);
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  } finally {
    setLoading(false);
  }
};

export const fetchUserSubscriptionData = async () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const userId = getUserId();
  try {
    const response = await fetch(
      `${apiUrl}/auth/get_user_subscription?user_id=${userId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};
